import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-palette',
  standalone: true,
  templateUrl: './rt-icon-palette.component.html',
  styleUrls: ['./rt-icon-palette.component.scss']
})
export class RtIconPaletteComponent {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
